function Key(props) {
  let colour;
  if (!["ENTER", "BACK"].includes(props.letter)) {
    if (props.guesses.join("").includes(props.letter)) {
      if (props.target.includes(props.letter)) {
        props.guesses.forEach(guess => {
          [...guess].forEach((letter, index) => {
            if (letter === props.letter && letter === props.target[index]) {
              colour = "green";
            }
          });
        });
        if (colour !== "green") {
          colour = "yellow";
        }
      } else {
        colour = "darkGrey";
      }
    } else {
      colour = "lightGrey";
    }
  }
  return (
    <div className="key" data-colour={colour}
      style={props.margin ? {} : { marginRight: "0px" }}
      data-width={["ENTER", "BACK"].includes(props.letter) ? "wide" : "normal"}
      onClick={() => props.handleInput({
        key: props.letter,
        which: props.letter === "ENTER" ? 13 : props.letter === "BACK" ? 8 : props.letter.charCodeAt(0)
      })}
    >
      {props.letter === "BACK" ? "<" : props.letter}
    </div>
  );
}

export default Key;